export class DocumentoSpesaDTO {
  importo: string;
  importoNetto?: string;
  iva: number;
  cig: string;
  cup: string;
  pad: string;
  lineaFinanziamento: string;
  scadenzaDurc: string;
  splitPayment: boolean;
}
